import { zodResolver } from "@hookform/resolvers/zod";
import dayjs from "dayjs";
import { useForm } from "react-hook-form";
import { OrderFormData, orderFormSchema } from "../OrderForm.schema";

export function useOrderForm(initialData?: Partial<OrderFormData>) {
  return useForm<OrderFormData>({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    resolver: zodResolver(orderFormSchema) as any,
    defaultValues: {
      dpPortfolioId: "",
      dpPortfolioName: "",
      dpPortType: "",
      dpModelType: "",
      advancedEKB: "",
      dpAmountToInvest: 0,
      dpOnOffPercentage: "0",
      dpManagementFee: "1.5",
      dpFeeType: "all" as const,
      dpOnOffAmount: 0,
      dpOnOffDate: dayjs().format("DD.MM.YYYY"),
      dpAccount: "",
      dpNewAccount: "",
      dpWithdrawal: 0,
      dpClosePortfolio: false,
      dpWithdrawalInternalTransfer: false,
      dpWithdrawalTargetPortfolioId: "",
      ordreModul: "no" as const,
      buyOrders: [],
      sellOrders: [],
      dpSavingsEnabled: false,
      dpSavingsAmount: undefined,
      dpSavingsDayOfMonth: undefined,
      dpSavingsAvtalegiro: false,
      dpSavingsFunds: [],
      dpWithdrawalEnabled: false,
      dpWdAccount: "",
      dpWdDayOfMonth: undefined,
      dpWdAmount: undefined,
      dpIpsWithdrawalAge: 62,
      dpIpsAnnualSavings: 0,
      askToAsk: false,
      moveAll: false,
      portDynamicSell: false,
      portDynamicWd: false,
      moveFrom: "",
      moveFromId: "",
      Instrument1: "",
      InstrumentAmt1: undefined,
      Instrument2: "",
      InstrumentAmt2: undefined,
      Instrument3: "",
      InstrumentAmt3: undefined,
      Instrument4: "",
      InstrumentAmt4: undefined,
      Instrument5: "",
      InstrumentAmt5: undefined,
      Instrument6: "",
      InstrumentAmt6: undefined,
      ...initialData,
    },
  });
}
